import { safetyDonts, safetyDos } from "@/mocks/home";

export default function SafetySection() {
  return (
    <section id="safety" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs md:text-sm">
            <i className="ri-shield-check-line" />
            安全提示
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            认准本页入口，远离假冒地址
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            地址频繁变动时，最容易被模仿的页面浑水摸鱼。下面这些做法和信号，能帮你快速分辨页面是否可信。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          <div className="rounded-lg border border-accent-200 bg-accent-50 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading font-bold text-lg text-accent-900">
              <i className="ri-checkbox-circle-line text-xl" />
              建议这样做
            </h3>
            <ul className="mt-4 flex flex-col gap-3">
              {safetyDos.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <i className="ri-check-line text-accent-600 mt-0.5 shrink-0" />
                  <span className="text-sm md:text-base text-foreground-800 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading font-bold text-lg text-primary-800">
              <i className="ri-alarm-warning-line text-xl" />
              出现这些请立即离开
            </h3>
            <ul className="mt-4 flex flex-col gap-3">
              {safetyDonts.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <i className="ri-close-line text-primary-600 mt-0.5 shrink-0" />
                  <span className="text-sm md:text-base text-foreground-800 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <span className="w-12 h-12 shrink-0 rounded-md bg-foreground-950 text-background-50 flex items-center justify-center">
            <i className="ri-lock-2-line text-2xl" />
          </span>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            记住一条最省心的判断标准：
            <strong className="font-medium text-foreground-950">本页只做地址导航，永远不需要你注册、登录或填写任何账号信息</strong>
            。任何要求你输入账号密码、验证码的页面，都不是本页提供的入口。
          </p>
        </div>
      </div>
    </section>
  );
}